var XScalarStability = /* @__PURE__ */ ((XScalarStability2) => {
  XScalarStability2["Deprecated"] = "deprecated";
  XScalarStability2["Experimental"] = "experimental";
  XScalarStability2["Stable"] = "stable";
  return XScalarStability2;
})(XScalarStability || {});
export {
  XScalarStability
};
//# sourceMappingURL=reference-config.js.map
